import { createFileRoute } from "@tanstack/react-router";
import i18n from "i18next";
import { CodesPage } from "~/pages/Codes/CodesPage";

export const Route = createFileRoute("/_app/codes")({
  head: () => ({ meta: [{ title: i18n.t("general:documentTitle.codes") }] }),
  component: CodesPage,
});
